import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddEducation, IEducation } from "../../Education.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useEditStream = (educationId: string) => {
  const [formData, setFormData] = useState<IAddEducation>({
    languageName: "",
    courseName: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [languages, setLanguages] = useState<any[]>([]);
  const [education, setEducation] = useState<IEducation | null>(null);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getStandard}/${educationId}`,
      });
      console.log("response", response);
      setEducation(response);
      populateFormData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const populateFormData = (educationData: IEducation) => {
    setFormData({
      languageName: educationData.languageName,
      courseName: educationData.standard,
    });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
  ) => {
    const { id, type, value } = e.target;

    if (type === "file") {
      const files = (e.target as HTMLInputElement).files; // Files can be null

      if (files && files.length > 0) {
        setFormData((prev) => ({
          ...prev,
          [id]: files[0], // Store the first file
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [id]: value, // Store the value for select and input elements
      }));
    }
  };

  const fetchLanguages = async () => {
    try {
      setLoading(true);
      const [coursesResponse, languagesResponse] =
        await Promise.all([
          ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
          ApiService({ method: "GET", endpoint: apiPaths.getlanguage }),
        ]);
      setLanguages(languagesResponse || []);

      if (!coursesResponse.length || !languagesResponse.length) {
        toast.error("No data found for languages.");
      }
    } catch (error) {
      console.error("Error fetching languages:", error);
      toast.error("Failed to fetch languages.");
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit: SubmitHandler<IAddEducation> = async (data) => {
    setLoading(true);
    // const formDataToSend = new FormData();
    // Object.entries(data).forEach(([key, value]) => {
    //   formDataToSend.append(key, value);
    // });
    console.log("data", data);
    console.log("form data", formData);
    try {
      const response = await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateStandard}/${educationId}`,
        data: data,
      });

        toast.success("Education updated successfully", {
          duration: 1000,
        });
        window.location.reload();
    } catch (error) {
      toast.error("Error updating status", {
        duration: 10000,
      });
      console.error("Error updating education:", error);
    }finally{
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [educationId]);

  const handleCancel = () => {
    window.location.reload();
  };

  return {
    loading,
    formData,
    languages,
    education,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useEditStream;
